import PropTypes from 'prop-types';
import KpiTrendChart from './KpiTrendChart.jsx';
import getRAG from '../../utils/ragStatus.js';

export default function ExpectedVsActualChart({ item, reportingPeriod }) {
    if (!item) return null;
    const { status } = getRAG(item, reportingPeriod);

    return (
        <KpiTrendChart
            item={item}
            reportingPeriod={reportingPeriod}
            status={status}
            variant="full"
        />
    );
}

ExpectedVsActualChart.propTypes = {
    item: PropTypes.object.isRequired,
    reportingPeriod: PropTypes.object
};
